export const setCookieToken = token => $cookies.set("token", token);
export const getCookieToken = () => $cookies.get("token_user");
export const deleteCookieToken = () => $cookies.remove("token", "/", process.env.VUE_APP_DOMAIN_COOKIES)

export const getLocalCheckToken = () => localStorage.getItem('check-token');
export const setLocalCheckToken = value => localStorage.setItem('check-token', value);

export const setPermissions = permissions => localStorage.setItem('permissions', permissions);
export const getPermissions = () => localStorage.getItem('permissions');